import React from "react";
import { Link } from "react-router";
import ElasticService from "src/services/elasticService";

const NEWTAB = "_blank";
const MIDDLECLICK = 1;

const isExternalHref = (url) => typeof url === "string" && /^https?:\/\//i.test(url);

const ApmLink = (props) => {
    const { parent, target, title, children, href, onClick, to, className, rel, ...rest } = props;
    const resolvedTarget = target ?? (isExternalHref(href) ? NEWTAB : undefined);
    const resolvedRel = resolvedTarget === NEWTAB ? (rel ?? "noopener noreferrer") : rel;

    const handleClick = (event) => {
        const normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);
        const sameTarget = resolvedTarget !== NEWTAB;

        let clickText = "";

        if (typeof children === "string") {
            clickText = children;
        } else if (React.isValidElement(children) && typeof children.props.children === "string") {
            clickText = children.props.children;
        } else if (Array.isArray(children)) {
            clickText = children.filter((child) => typeof child === "string").join(" ");
        }

        ElasticService.createTransaction("click", {
            click_element: "link",
            click_parent: parent,
            click_text: clickText,
            click_title: title,
            click_target: sameTarget ? "internal" : "external",
        });

        if (sameTarget && normalClick && href) {
            event.preventDefault();
            window.location.href = href;
        }

        if (onClick) {
            onClick(event);
        }
    };

    if (to) {
        return (
            <Link className={className} to={to} onClick={handleClick}>
                {children}
            </Link>
        );
    }

    return (
        <a href={href} target={resolvedTarget} rel={resolvedRel} title={title} className={className} onClick={handleClick} {...rest}>
            {children}
        </a>
    );
};

export default ApmLink;
